
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRoles,
  fetchPermissions,
  assignRolePermissions,
  fetchRolePermissions,
} from "../redux/actions/roleActions";
import theme from "../components/shared/theme";

const AssignPermissionToRole = () => {
  const dispatch = useDispatch();
  const { roles, permissions, rolePermissions, loading, error } = useSelector(
    (state) => state.role
  );

  const [selectedRole, setSelectedRole] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(fetchPermissions());
  }, [dispatch]);

  useEffect(() => {
    if (selectedRole) {
      dispatch(fetchRolePermissions(selectedRole));
    } else {
      setSelectedPermissions([]);
    }
  }, [dispatch, selectedRole]);

  useEffect(() => {
    if (rolePermissions?.length && selectedRole) {
      const perms = rolePermissions
        .filter((p) => p.role_id === parseInt(selectedRole))
        .map((p) => p.permission_id);
      setSelectedPermissions(perms);
    }
  }, [rolePermissions, selectedRole]);

  const handlePermissionToggle = (permId) => {
    setSelectedPermissions((prev) =>
      prev.includes(permId)
        ? prev.filter((id) => id !== permId)
        : [...prev, permId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedRole) {
      dispatch(
        assignRolePermissions({
          role_id: selectedRole,
          permissionIds: selectedPermissions,
        })
      );
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">
          Assign Permissions to Role
        </h1>

        {error && (
          <div className="bg-red-100 text-red-700 border border-red-300 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Role Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Select Role <span className="text-red-500">*</span>
            </label>
            <select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
            >
              <option value="">-- Select Role --</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.role_name}
                </option>
              ))}
            </select>
          </div>

          {/* Permissions */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Permissions</label>
            <div className="bg-gray-50 border border-gray-300 rounded-md p-3 max-h-64 overflow-y-auto space-y-2">
              {permissions.length === 0 ? (
                <p className="text-sm text-gray-500">No permissions available.</p>
              ) : (
                permissions.map((perm) => (
                  <label key={perm.id} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={selectedPermissions.includes(perm.id)}
                      onChange={() => handlePermissionToggle(perm.id)}
                    />
                    <span className="text-sm text-gray-700">{perm.permission_name}</span>
                  </label>
                ))
              )}
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || !selectedRole}
            className={`w-full px-4 py-2 text-white font-medium rounded-md transition ${
              loading || !selectedRole
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {loading ? "Assigning..." : "Assign Permissions"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AssignPermissionToRole;
